export default __webpack_public_path__ + "static/media/video-poster.0a4a24db.png";